<template>
    <svg :class="svgClass">
        <use v-bind="{'xlink:href': href}" fill="currentColor"></use>
    </svg>
</template>

<script>
    export default {
        name: "SvgIcon",
        props: {
            svgClass: {
                type: [String, Array, Object],
                required: false,
                default: ''
            },
            icon: {
                type: String,
                required: false,
                default: 'save'
            }
        },
        computed: {
            href() {
                return `/assets/images/fontawesome-icons.svg?f#${this.icon}`
            }
        }
    }
</script>
